/**
 * Classe respons'el pelos eventos de adicionar o item depois que o survey estiver como released.
 *
 * Created by adalto on 5/16/14.
 */


Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.AddItemAfterReleased = function (questionData) {

    this.questionData = questionData;

    var _questionId;
    var _questionType;

    this.setQuestionId = function (questionId) {
        _questionId = questionId;
    };

    this.setQuestionType = function (questionType) {
        _questionType = questionType;
    };

    var appendInputText = function () {

        var formQuestions = document.querySelector("#Survey .questionContent");
        var text = document.createElement('input');

        text.type = 'text';
        text.className = 'newItem';

        if (formQuestions) {
            formQuestions.appendChild(text);
        }

    };

    var validateNewItem = function (newItemValue) {

        var errorMessages = [];

        if (newItemValue) {

            if (Greenmile.Survey.Data.itemAlreadyExists(_questionId, newItemValue)) {
                errorMessages.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.DuplicateAnswers'));
            }

        } else {
            errorMessages.push(Monet.I18n.getResourcesByKey('Greenmile.Survey.answerCannotIsEmpty'));
        }

        return errorMessages;

    };

    var renderSelectOne = function (item) {

        var radio,
            edit   = Greenmile.Survey.Widgets.editLink(item),
            remove = Greenmile.Survey.Widgets.removeLink(item),
            link   = Greenmile.Survey.Widgets.answerLink(item, {id: _questionId}),
            label,
            question,
            questionEl,
            drag   = document.createElement('div');

        radio = new Monet.UI.Fields.Render({
            type: 'RADIO',
            name: _questionId,
            value: item.value,
            label: item.value
        }, 'Survey').render();

        label = radio.rootEl.getElementsByTagName('label')[0];
        label.title = item.value;

        radio.rootEl.id = item.id;
        radio.rootEl.appendChild(edit);
        radio.rootEl.appendChild(remove);
        radio.rootEl.appendChild(link);

        question = Greenmile.Survey.Data.findQuestion(_questionId);
        questionEl = question.el.querySelector('.optionGroup');

        var radioInput = radio.rootEl.querySelector('input[type="radio"]');
        drag.className = 'dragQuestionDomain';
        radio.rootEl.insertBefore(drag, radioInput);

        if (questionEl) {
            questionEl.appendChild(radio.rootEl);
        }

        question.surveyQuestionDomain.push(item);

    };

    var renderSelectMany = function (item) {
        var checkbox,
            edit   = Greenmile.Survey.Widgets.editLink(item),
            remove = Greenmile.Survey.Widgets.removeLink(item),
            label,
            question,
            questionEl,
            drag   = document.createElement('div');

        checkbox = new Monet.UI.Fields.Render({
            type: 'CHECKBOX',
            name: _questionId,
            label: item.value
        }, 'Survey').render();

        label = checkbox.rootEl.getElementsByTagName('label')[0];
        label.title = item.value;

        checkbox.rootEl.id = item.id;
        checkbox.rootEl.appendChild(edit);
        checkbox.rootEl.appendChild(remove);

        var checkboxInput = checkbox.rootEl.querySelector('input[type="checkbox"]');
        drag.className = 'dragQuestionDomain';
        checkbox.rootEl.insertBefore(drag, checkboxInput);

        question = Greenmile.Survey.Data.findQuestion(_questionId);
        questionEl = question.el.querySelector('.answerContent');

        if (questionEl) {
            questionEl.appendChild(checkbox.rootEl);
        }

        question.surveyQuestionDomain.push(item);

    };

    var renderSkuSelectMany = function (items) {
        var grid = this.questionData.questionObject.grid.table;
        var dataView = this.questionData.questionObject.grid.dataView;
        var data = grid.getData().data.map(function(entityModel){
          return entityModel.idOfObject;
        });
        var founded;
        items.forEach(function(item) {
            if (!founded) {
                founded = data.reduce(function(founded, elem){
                    if (elem === Number(item.id)) {
                        founded = elem;
                    }
                    return founded;
                }, null);
            }
            data.push(Number(item.id));
        }, this);

        if (founded) {
            return Monet.I18n.getResourcesByKey('Greenmile.Survey.DuplicateAnswers');
        }

        var entityRestriction = JSON.parse(this.questionData.entityRestriction);
        entityRestriction.criteriaChain[0].and[0] = { in: data, attr: 'id' };
        this.questionData.entityRestriction = JSON.stringify(entityRestriction);

        var options = {
          grid: grid,
          dataView: dataView
        };
        this.questionData.questionObject.grid.getData(grid, options, true);

        return null;
    }.bind(this);

    var addNewItemToQuestion = function (item) {

        if (_questionType === 'PICKLIST') {

            renderSelectOne(item);

        } else if (_questionType === 'PICKLIST_MULTISELECT') {

            renderSelectMany(item);

        } else if (_questionType === 'ENTITY') {

            return renderSkuSelectMany(item);

        }

    }.bind(this);

    var addSkuEventListeners = function () {

        if(App.Forms.SurveyReleasedPowerLookup) {
            delete App.Forms.SurveyReleasedPowerLookup;
        };

        const displayKey = (this.questionData.entity.key === 'StopView') ? 'stop.key' :'description'
        const questionContent = document.querySelector('.questionContent');
        const lookup = new Monet.UI.Fields.PowerLookupList();       
        
        lookup.setNameSpace('SurveyReleasedPowerLookup');
        lookup.setDisplayKey(displayKey);
        lookup.setLookUpEntity(this.questionData.entity.key);
        lookup.render();
        lookup.setId('entityAddItem');
        questionContent.appendChild(lookup.rootEl);

        questionContent.parentElement.style.height = '500px';
        const lookupList = questionContent.querySelector('.container_lookuplist_added');
        lookupList.style.width = '96%';
        lookupList.style.minHeight = '300px';
        lookupList.style.marginLeft = '0';

        const saveButton = document.querySelector('#LinkFormSaveButton');
        const cancelButton = document.querySelector('#LinkFormCancelButton');

        saveButton.addEventListener('click', function () {
            const exception = addNewItemToQuestion(lookup.getValue());
            if (exception) {
                new Greenmile.Components.AlertModal(exception)
                    .show();
            } else {
                Greenmile.Survey.Sidebar.dismissQuestionForm();
            }

        }.bind(this));

        cancelButton.addEventListener('click', function () {
            Greenmile.Survey.Sidebar.dismissQuestionForm();
        });

    }.bind(this);

    var addEventListeners = function () {

        var saveButton   = document.querySelector('#LinkFormSaveButton'),
            cancelButton = document.querySelector('#LinkFormCancelButton');

        saveButton.addEventListener('click', function () {

            var newItem = document.querySelector("#Survey .questionContent input[type='text']").value;

            var errors = validateNewItem(newItem);

            if (errors.length) {

                Greenmile.Survey.Sidebar.clearErrorMessage();
                Greenmile.Survey.Sidebar.showErrors(errors);

            } else {

                var id = new Date().getTime() + Math.floor((Math.random() * 1000) + 1);
                var item = { id: id, value: newItem, addAfterRelease: true, isNew: true };

                addNewItemToQuestion(item);
                Greenmile.Survey.Sidebar.dismissQuestionForm();

            }

        });

        cancelButton.addEventListener('click', function () {
            Greenmile.Survey.Sidebar.dismissQuestionForm();
        });

    };

    this.show = function () {
        var questionData = Greenmile.Survey.Data.findQuestion(_questionId);
        Greenmile.Survey.Sidebar.createOverlayAfterReleased(questionData);

        if (questionData.questionType !== 'ENTITY') {

            appendInputText();
            addEventListeners();

        } else {

            addSkuEventListeners();

        }

    };


};
